import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context10; _forEachInstanceProperty(_context10 = ownKeys(source, true)).call(_context10, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context11; _forEachInstanceProperty(_context11 = ownKeys(source)).call(_context11, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getEntityItem } from './data';
import { ENTITIES, ITEMS, RELATED, PAGINATION, DATA, ETAG } from './constants';
import { defaultPaginationState } from './defaults';
import { createEtag } from './etags';
import { get, isArray, merge } from 'lodash';
/**
 * Get related data for given type and item id
 * @param  {Object} state
 * @param  {string} type
 * @param  {string} id
 * @return {Object}
 */

export function getEntityItemRelateds(state, type, id) {
  var _context, _context2, _context3, _context4;

  var related = get(state, _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "".concat(ENTITIES, ".")).call(_context4, type, ".")).call(_context3, ITEMS, ".")).call(_context2, id, ".")).call(_context, RELATED), {});
  var rels = {};

  var _loop = function _loop(name) {
    var rel = related[name];

    if (rel) {
      var _context5;

      var _type = rel.type;
      var itemIsArray = false;

      if (isArray(_type)) {
        _type = _type[0];
        itemIsArray = true;
      }

      var items = _mapInstanceProperty(_context5 = rel[ITEMS]).call(_context5, function (itemId) {
        var item = getEntityItem(state, rel.type, itemId); // Load relations recursively to get nested relations

        var itemRelateds = getEntityItemRelateds(state, rel.type, itemId) || {};
        return _objectSpread({}, item ? item[DATA] : {}, {}, itemRelateds);
      });

      if (itemIsArray) {
        var _rels$name;

        // 1:n relationship needs extra information such as
        //  pagination etc.
        rels[name] = (_rels$name = {}, _defineProperty(_rels$name, ITEMS, items), _defineProperty(_rels$name, PAGINATION, merge({}, defaultPaginationState, rels[PAGINATION] || {})), _rels$name);
      } else {
        // 1:1 relationship can be handled like direct data fed
        //  into the item object
        rels[name] = items[0];
      }
    }
  };

  for (var name in related) {
    _loop(name);
  }

  return rels;
}
export function removeRelatedItem(state, type, id) {
  var newState = _objectSpread({}, state);

  if (!newState[ITEMS]) {
    return state;
  }

  var _loop2 = function _loop2(_id) {
    var _context6, _context7, _context8, _context9;

    var items = get(newState, _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = _concatInstanceProperty(_context9 = "".concat(ITEMS, ".")).call(_context9, _id, ".")).call(_context8, RELATED, ".")).call(_context7, type, ".")).call(_context6, ITEMS));

    if (items) {
      newState[ITEMS][_id][RELATED][type][ITEMS] = _filterInstanceProperty(items).call(items, function (rId) {
        return rId !== _id;
      });
    }

    newState[ITEMS][_id][ETAG] = createEtag();
  };

  for (var _id in newState[ITEMS]) {
    _loop2(_id);
  }

  return newState;
}